import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export function httpLoaderFactory(http: HttpClient) {
  return {
    getTranslation: (lang: string) =>
      http.get(`${environment.api.host}/i18n/${lang}`, {
        headers: { 'skip-loading': 'true' },
      }),
  };
}
